<template>
  <base-list-view
    @state-scroll="scrollList"
  >
    <div class="marked-list">
      <div
        v-for="exhibitor in exhibitorsList"
        :key="exhibitor.id"
        class="exhibitor-item"
      >
        <exhibitor-card
          :exhibitor-id="exhibitor.id"
          :logo="exhibitor.logo"
          :company="exhibitor.name"
          :stand="exhibitor.stand"
          :marked="!!getMarkedCompanyByID(exhibitor.id)"
          @marking="markingCompany"
        />
      </div>
      <system-card
        v-if="systemMessage"
        :system-message="systemMessage"
        :cbFunc="repeatGetPage"
      />
      <pre-loader v-if="isLoading"/>
    </div>
  </base-list-view>
</template>
<script>
import { DateTime } from 'luxon';
import appBaseNav from '@/components/mixins/appBaseNav';
import exhibitors from '@/components/mixins/methodsExhibitors';
import banners from '@/components/mixins/methodsBanners';

import baseListView from '@/components/shared/baseListView.vue';
import SystemCard from '@/components/shared/upCard/SystemCard.vue';
import ExhibitorCard from '@/components/shared/upCard/ExhibitorCard.vue';

export default {
  name: 'markedList',
  components: { baseListView, SystemCard, ExhibitorCard },
  props: {
    launchDownload: {
      type: Boolean,
    },
    locale: {
      type: String,
    },
  },
  mixins: [appBaseNav, exhibitors, banners],
  data() {
    return {
      exhibitorsList: [],
      markedExhibitors: [],
      isLoading: true,
      curPage: 1,
      countPage: null,
      searchInput: null,

      isLastDownloaded: false,
      systemMessage: null,
    };
  },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('markedListPage.header_title'));
    this.loadMarkedExhibitors();
    Promise.all([
      this.getBanner('exhibitor', this.$store.getters.getBannerExhibitorTs),
    ])
      .then(([
        banner,
      ]) => {
        this.isLoading = false;
        if (banner && Object.keys(banner).length) {
          console.log('Banner');
          this.$emit('showBanner', banner);
          const nowMilis = DateTime.now().toMillis();
          localStorage.setItem('bannerExhibitorTs', nowMilis);
          this.$store.commit('setBannerExhibitorTs', nowMilis);
        }

        this.getPage();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
      });
  },
  methods: {
    getPage() {
      if (this.countPage === null || this.curPage <= this.countPage) {
        this.isLoading = true;

        this.getExhibitorList(this.curPage, this.searchInput)
          .then((data) => {
            this.isLoading = false;
            this.$emit('turnOff', {
              stateDownload: false,
              stateCheckInbox: false,
            });
            if (data?.results && Array.isArray(data.results)) {
              data.results.forEach((company) => {
                if (this.getMarkedCompanyByID(company.id)) {
                  this.exhibitorsList.push(company);
                }
              });

              // this.exhibitorsList = [...this.exhibitorsList, ...data.results];
              console.log(this.exhibitorsList);
              this.countPage = data.num_pages;
              this.curPage = data.page;
              this.isLastDownloaded = true;
              this.systemMessage = null;
            } else {
              this.isLastDownloaded = false;
              this.systemMessage = this.$t('system.bad_connect');
            }
          })
          .catch((error) => {
            console.error('getPage()::', error);
          });
      }
    },
    loadMarkedExhibitors() {
      const exhID = this.$store.getters.getExhId;
      const markedList = localStorage.getItem(`exh-${exhID}-marked`);
      if (markedList === null) {
        localStorage.setItem(`exh-${exhID}-marked`, JSON.stringify([]));
      } else {
        JSON.parse(markedList).forEach((item) => {
          if (item.type === 'exhibitors') {
            this.markedExhibitors.push(item);
          }
        });
      }
      console.log(markedList);
    },
    saveMarkedExhibitors() {
      const exhID = this.$store.getters.getExhId;
      localStorage.setItem(`exh-${exhID}-marked`, JSON.stringify(this.markedExhibitors));
    },
    scrollList(prop) {
      if (prop.endPage && !this.isLoading && this.isLastDownloaded) {
        this.curPage += this.isLastDownloaded ? 1 : 0;
        this.getPage();
      }
    },
    repeatGetPage() {
      this.getPage();
    },
    showFilter(data) {
      this.curPage = 1;
      this.participantsList = [];
      this.searchInput = data;
      this.getPage();
    },
    markingCompany(item) {
      const company = this.exhibitorsList.find((companyItem) => companyItem.id === item);
      const markedCompany = this.markedExhibitors
        .findIndex((companyItem) => companyItem.id === item);

      if (markedCompany === -1) {
        this.markedExhibitors.push({
          type: 'exhibitors',
          id: company.id,
        });
      } else {
        this.markedExhibitors.splice(markedCompany, 1);
      }

      this.saveMarkedExhibitors();
      console.log('list', company);
    },
    getCompanyByID(companyID) {
      return this.exhibitorsList.find((company) => company.id === companyID);
    },
    getMarkedCompanyByID(companyID) {
      return this.markedExhibitors.find((company) => company.id === companyID);
    },
  },
};
</script>
<style lang="scss" scoped>
.marked {
  &-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  &-list .exhibitor-item {
    flex: 1 1 140px;
    max-width: calc(50% - 6px);
    @media (min-width: 480px) {
      flex: 1 1 180px;
      max-width: calc(33.333% - 6px);
    }

    & .upCard {
      border-radius: 10px;
      padding: 10px;
      height: 203px;
    }
  }
}
</style>
